import type { rechargeType } from '@/types/viewsType/rechargeType'
import { getResult, apiChicChargePopup } from '@/api/recharge'
import * as Sentry from '@sentry/nuxt'

export const useRechargeStore = defineStore({
  id: 'recharge',
  state: () => ({
    rechargeList: {} as Record<number, rechargeType[]>, //所有用户的订单{ uid:[], uid:[] }
    num: 10, //一个订单限制查询次数
    uid: 0, //是0表示未登录 不进行递归查询订单
    timer: 0, //定时器
    /**  App使用的首充倒计时 豪秒*/
    appFirstCjargeTime: 0 as number
  }),
  actions: {
    /** 设置App使用的首充倒计时 */
    setAppFirstCjargeTime(v: number) {
      this.appFirstCjargeTime = v
    },
    /** 获取App使用的首充倒计时 */
    getAppFirstChargeInfo() {
      const roomStore = useRoomStore()
      if (roomStore.isApp) {
        apiChicChargePopup().then((res) => {
          if (res.code === 200) {
            this.setAppFirstCjargeTime(
              res.data ? res.data.countdownMillis || 0 : 0
            )
          }
        })
      }
    },
    // 设置uid
    setUid() {
      if (localStorage.getItem('loginInfo')) {
        this.uid = JSON.parse(localStorage.getItem('loginInfo') as string).uid
      }
    },
    // 重置uid
    resetData() {
      this.uid = 0
    },
    // 插入payermax订单记录
    setRechargeList(chargeInfo: rechargeType) {
      const uid = this.uid
      if (!this.rechargeList[uid]) {
        this.rechargeList[uid] = []
      }
      this.rechargeList[uid].push(chargeInfo)
    },
    // 查询订单结果
    requestRechargeResult() {
      const uid = this.uid
      const userStore = useUserStore()
      if (this.rechargeList[uid] && this.rechargeList[uid].length && uid) {
        const chargeInfo = this.rechargeList[uid][0]
        const { orderId, chargeProdId, dollarMoney, prodName } = chargeInfo
        getResult({ chargeRecordId: orderId }).then((res) => {
          // console.log(res)
          const { data, code } = res
          if (code === 200) {
            // 0：等待，1：成功，2：失败
            switch (data) {
              case 0:
                this.num--
                if (!this.num) {
                  eventTracking.eventLog(
                    eventTracking.eventId.payment_result_waiting
                  ) // 等待埋点
                  this.deleteOrder(orderId)
                  this.num = 10
                }
                break
              case 1:
                eventTracking.eventLog(
                  eventTracking.eventId.payment_result_success
                ) // 成功埋点
                this.splitPurchaseOrder(
                  orderId,
                  dollarMoney,
                  'USD',
                  chargeProdId,
                  prodName
                )
                this.deleteOrder(orderId)
                userStore.requestUserInfo()
                break
              case 2:
                eventTracking.eventLog(
                  eventTracking.eventId.payment_result_fail
                ) // 失败埋点
                this.rechargeList[uid].splice(
                  this.rechargeList[uid].findIndex(
                    (v) => v.orderId === orderId
                  ),
                  1
                )
                break
              default:
                //异常状态
                eventTracking.eventLog(
                  eventTracking.eventId.payment_result_abnormal
                ) // 异常埋点
                Sentry.withScope(function (scope) {
                  scope.addEventProcessor(function (event) {
                    // 向事件添加额外信息
                    event.extra = {
                      transaction_id: chargeInfo.orderId as string
                    }
                    return event
                  })
                  Sentry.captureMessage('order error')
                })
                this.deleteOrder(orderId)
                break
            }
            this.timer && window.clearTimeout(this.timer)
            this.timer = window.setTimeout(() => {
              this.requestRechargeResult()
            }, 1500)
          }
        })
      }
    },
    /**
     *  拆分购买订单事件
     *  orderId: 订单id
     *  money：金额
     *  currency: 'USD' | 'INR' 货币类型
     *  chargeProdId: 产品ID
     *  prodName： 产品名称
     *
     * GATG在拆单处理，FB埋点不做拆单，
     **/
    splitPurchaseOrder(
      orderId: string,
      dollarMoney: number,
      currency: 'USD',
      chargeProdId: string,
      prodName: string
    ) {
      // FB埋点不做拆单，因为会有警告
      eventTracking.eventLog(eventTracking.eventIdFB.Purchase, {
        value: dollarMoney,
        currency: currency,
        content_ids: chargeProdId,
        content_name: prodName,
        order_id: orderId
      })
      // GTAG做拆单处理
      const MONEY_BASE = 4.99 // 金额拆分基数,常量
      const splitNum =
        dollarMoney >= MONEY_BASE ? Math.floor(dollarMoney / MONEY_BASE) : 1 // 拆分数量，拆分成n单，向下取整
      for (let i = 1; i <= splitNum; i++) {
        setTimeout(() => {
          console.log(
            `循环次数, ${i};orderId=${orderId}_${i},金额=${splitNum === 1 ? dollarMoney : MONEY_BASE},货币：${currency},商品ID：${chargeProdId},商品名称：${prodName}`
          )
          eventTracking.eventLog(eventTracking.eventIdGtag.purchase, {
            transaction_id: `${orderId}_${i}`,
            value: splitNum === 1 ? dollarMoney : MONEY_BASE,
            currency: currency,
            items: [
              {
                item_id: chargeProdId as string,
                item_name: prodName as string
              }
            ]
          })
        }, 1000 * i)
      }
    },
    // 查询完毕删除订单
    deleteOrder(orderId: string) {
      const uid = this.uid
      if (this.rechargeList[uid]) {
        const rechargeFindIndex = this.rechargeList[uid].findIndex(
          (v) => v.orderId === orderId
        )
        if (rechargeFindIndex !== -1) {
          this.rechargeList[uid].splice(rechargeFindIndex, 1)
        }
      }
    }
  },
  persist: {
    key: 'rechargeStore',
    paths: ['rechargeList']
  }
})
